var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMistake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2971 27.2367C58.2233 29.8334 58.7276 32.6305 58.7276 35.5453C58.7276 49.2018 47.6569 60.2725 34.0004 60.2725C31.0855 60.2725 28.2885 59.7682 25.6918 58.842L22.1253 62.4086C25.7562 64.016 29.774 64.9089 34.0004 64.9089C50.2174 64.9089 63.364 51.7624 63.364 35.5453C63.364 31.3189 62.4711 27.3011 60.8637 23.6702L57.2971 27.2367Z",
    fill: "#F56B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27308 35.5453C9.27308 38.8875 9.93618 42.0749 11.138 44.983L7.6348 48.4862C5.71497 44.5822 4.63672 40.1896 4.63672 35.5453C4.63672 19.3282 17.7833 6.18164 34.0004 6.18164C38.6447 6.18164 43.0373 7.25989 46.9413 9.17972L43.4381 12.6829C40.53 11.4811 37.3426 10.818 34.0004 10.818C20.3439 10.818 9.27308 21.8888 9.27308 35.5453Z",
    fill: "#F56B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.008 35.5887L4.63672 61.9599L11.7404 62.5079L34.8365 39.4119L45.7703 50.3306L49.5961 46.5047L38.6699 35.5784L65.7863 8.46209L58.6826 7.91404L34.844 31.7526L22.1846 19.0931L18.3573 22.9554L31.008 35.5887Z",
    fill: "#F56B4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistake);
export default __webpack_public_path__ + "static/media/mistake.427114e8.svg";
export { ForwardRef as ReactComponent };